module.exports = __webpack_public_path__ + "img/B4-20190410_04.38a27464.jpg";